import React from 'react';
import { MdImage } from 'react-icons/md';

import { Flex, Icon, Text } from '@lucidhq/lucidium';
import { BackgroundColorProperty } from '@lucidhq/lucidium/lss/csstypes';

import { t } from '~/utils/i18n';

type UploadButtonProps = {
  onClick: () => void;
  onDrop: React.DragEventHandler<HTMLDivElement>;
  onDragOver: React.DragEventHandler<HTMLDivElement>;
  onDragLeave: React.DragEventHandler<HTMLDivElement>;
  isDragging: boolean;
};

export const UploadButton = ({
  onClick,
  onDrop,
  onDragOver,
  onDragLeave,
  isDragging
}: UploadButtonProps) => {
  return (
    <Flex
      onClick={onClick}
      onDrop={onDrop}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      lss={{
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#f8f8f8' as BackgroundColorProperty,
        borderRadius: 'md',
        minHeight: '15rem',
        width: '100%',
        cursor: 'pointer'
      }}
    >
      <Flex
        lss={{
          flexDirection: 'column',
          gap: '12px',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Icon size={48} as={MdImage} />
        <Flex
          lss={{
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Text lss={{ fontWeight: 'bold' }}>
            {isDragging
              ? t('campaignManager.media.uploadModal.dropFile')
              : t('campaignManager.media.uploadModal.dragAndDropFile')}
          </Text>
          <Text>{t('campaignManager.media.uploadModal.chooseFile')}</Text>
        </Flex>
      </Flex>
    </Flex>
  );
};
